import { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import Empty from 'constants/empty';
import LanguageLocale from 'utils/LanguageLocale';
import AutoReplenishmentActions from 'actions/AutoReplenishmentActions';
import AutoReplenishmentEN from 'components/RichProfile/MyAccount/AutoReplenishment/locales/AutoReplenishment_en_US';
import AutoReplenishmentFR from 'components/RichProfile/MyAccount/AutoReplenishment/locales/AutoReplenishment_fr_CA';

const { getLocalisedDataFromResource } = LanguageLocale;
const getText = getLocalisedDataFromResource(AutoReplenishmentEN, AutoReplenishmentFR);

/**
 * Custom hook for Auto Replenishment Main component.
 * Manages localization and Contentful content loading based on feature flags.
 *
 * @returns {Object} Hook state
 * @returns {Object} returns.localization - Localized strings for the component
 * @returns {string} returns.localization.pageTitle - Page title text
 */
const useAutoReplenishmentMain = () => {
    const dispatch = useDispatch();

    const localization = useMemo(
        () => ({
            pageTitle: getText('autoReplenish')
        }),
        []
    );

    const featureFlags = useMemo(() => {
        const config = (typeof Sephora !== 'undefined' && Sephora.configurationSettings) || Empty.Object;

        return {
            isAutoReplenishEmptyHubEnabled: config.isAutoReplenishEmptyHubEnabled
        };
    }, []);

    useEffect(() => {
        if (featureFlags.isAutoReplenishEmptyHubEnabled) {
            dispatch(AutoReplenishmentActions.loadContentfulContent());
        }
    }, [dispatch, featureFlags.isAutoReplenishEmptyHubEnabled]);

    return {
        localization
    };
};

export default useAutoReplenishmentMain;
